<template>
	<div class="c-editor-sidebar">
		<div class="c-editor-sidebar__userback" v-if="route">
			<router-link
			class="st-btn st-btn--full st-btn--dark st-btn--small st-btn--icon"
			:to="route">
				<i class="fa fa-angle-left" aria-hidden="true"></i> {{ $t('Back to {name}', {name: backtotext}) }}
			</router-link>
		</div>
		<c-chart-list
			:data="charts"
			:child="false"
			:canHaveChilds="(presentation.addablecharts && presentation.addablecharts.length > 0)"></c-chart-list>

		<div class="c-editor-sidebar__userback" v-if="presentation.fancyname && Object.keys(charts).length > 6">
			<router-link class="st-btn st-btn--full st-btn--dark st-btn--small st-btn--icon" :to="{ name: 'user-edit', params: { uid : presentation.id.toString(), role: presentation.role.toString() }}"><i class="fa fa-angle-left" aria-hidden="true"></i> {{ $t('Back to {name}', {name: presentation.fancyname}) }}</router-link>
		</div>
	</div>
</template>

<script>

import storeutilis 			from '@/helpers/storeutilis';
import CChartList 			from '@/components/p-editor/c-chart-list';
export default {
	name: 'c-editor-sidebar',
	components: {
		CChartList
	},
	computed: {
		route(){
			if(this.edituser.type){
				return {
					name: this.edituser.type,
					params: {
						id : this.edituser.id
					}
				}
			}
			return false;
		},
		backtotext(){
			if(this.presentation.type == 'user') return this.edituser.fancyname;
			return '';
		},
		edituser(){
			return this.$store.getters.edituser;
		},
		presentation(){
			return this.$store.getters.presentation;
		},
		charts(){
			return storeutilis.orderCharts(this.$store.getters.charts);
		},
	},
}
</script>

<style lang="scss">
.c-editor-sidebar__userback {
	margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/p-editor/c-editor-sidebar.vue